import { openModalGlobal } from '../../../js/components/modal';
import { handleViewMap } from '../../../js/components/other-actions';

const VIEW_ALL_BTN_ID = 'view-all-apartment-features-btn';
const VIEW_PROP_MAP_ID = 'view-property-map-btn';

export const propertyFeatures = () => {

  const viewAllBtnHandler = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const featureDetails = e.currentTarget.closest('.features-details');
    if (featureDetails) {
      const titleEl = featureDetails.querySelector('h2');
      const listEl = featureDetails.querySelector('ul');
      const div = document.createElement('div');
      div.classList.add('property-modal-content');
      div.appendChild(titleEl.cloneNode(true));
      div.appendChild(listEl.cloneNode(true));
      openModalGlobal(div, 'auto');
    }
  }

  document.querySelectorAll(`#${VIEW_ALL_BTN_ID}`).forEach((btn) => {
    btn.addEventListener('click', viewAllBtnHandler);
  });

  document.querySelectorAll(`#${VIEW_PROP_MAP_ID}`).forEach((btn) => {
    btn.addEventListener('click', handleViewMap);
  });
}



// WEBPACK FOOTER //
// ./src/templates/components/property-features/property-features.js